<template>
    <div class="slideshow-block" v-if="images" :class="[{'hover-prev':hover_prev},{'hover-next':hover_next}]">
        <swiper :options="swiper_options" ref="swiper" v-images-loaded:on.progress="imageLoaded">
            <swiper-slide v-for="(image, index) in images" :key="index">
                <div class="item">
                    <img :src="image.src" :alt="image.alt" @click="nextSide" ref="img">
                    <div class="info" ref="caption">
                        <span v-if="image.caption" v-html="image.caption" :title="image.caption"></span>
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="prev js-prev" slot="button-prev" @mouseover="hover_prev = true" @mouseleave="hover_prev = false"></div>
            <div class="next js-next" slot="button-next" @mouseover="hover_next = true" @mouseleave="hover_next = false"></div>
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import imagesLoaded from 'vue-images-loaded';

export default {
    name: 'slideshow-block',

    data() {
        return {
            images: [],
            hover_prev: false,
            hover_next: false,
            swiper_options: {
                // effect: 'fade',
                effect: 'coverflow',
                // loop: true,


                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: true,
                grabCursor: true,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 40,
                    modifier: 2,
                    slideShadows : false,
                },
                navigation: {
                    nextEl: '.js-next',
                    prevEl: '.js-prev',
                },
                pagination: {
                    el: '.swiper-pagination'
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                on: {
                  // init: () => {
                  //     // console.log(this.$refs.img)
                  //     this.$refs.img.forEach(img => {
                  //         console.log(img.getBoundingClientRect())
                  //     });
                  // },
                  slideChange: (a,b,c) => {
                    // let swiper = this.$refs.swiper.$swiper;
                    // let inx = swiper;
                    let index = this.$refs.swiper.$swiper.activeIndex;
                    let img = this.$refs.img[index];
                    let caption = this.$refs.caption[index];
                    let img_pos = img.getBoundingClientRect();

                    // console.log(caption, img_pos.width)
                    caption.style.width = img_pos.width + 'px';
                  }
                }
            },
        }
    },

    components: {
        Swiper,
        SwiperSlide,
    },

    directives: {
        imagesLoaded,
    },

    props: {
        hide_pager: {
            type: Boolean,
            default: false,
        },
        data: Object,
    },

    methods: {
        nextSide() {
            this.$refs.swiper.$swiper.slideNext();
        },

        imageLoaded(instance, image) {
            let box = image.img.parentNode;
            let info = box.querySelector('.info');
            let box_pos = box.getBoundingClientRect();
            let img_pos = image.img.getBoundingClientRect();

            let top = ((img_pos.height + (box_pos.height - img_pos.height)/2)/box_pos.height) * 100;
            let left = ((box_pos.width - img_pos.width)/2 / box_pos.width) * 100;

            info.style.top = `${top}%`;
            info.style.left = `${left}%`;
            info.style.width = `${img_pos.width}px`;
        },


    },


    mounted() {
        // console.log(this.data , this.data.images)
        if (this.data && this.data.images) {
            this.data.images.forEach(item => {
                // console.log(item)
                this.images.push({
                    src: item.sizes.large,
                    alt: item.alt,
                    caption: item.caption,
                })
            });
        }

        //images
        // this.$nextTick(()=>{
        //     if (this.data && this.data.medias.length === 1) {
        //         // console.log(this.$refs.swiper.$swiper)
        //         // this.$refs.swiper.$swiper.destroy(true, true);
        //         this.hide_arrow = true;
        //     }
        // });

    },
}
</script>

<style lang="scss">
    .slideshow-block {
        width: 100%;
        position: relative;

        .prev,
        .next {
            position: absolute;
            cursor: pointer;
            width: 15rem;
            z-index: 99;
            top: 0;
            height: 100%;

            &:hover,
            &:focus {
                outline: none;
            }
        }

        .next {
            right: 0;
        }

        .prev {
            left: 0;
        }

        .swiper-container {
            height: 46rem;
            padding-bottom: 4rem;
            background: var(--gray);
        }

        .swiper-wrapper,
        .swiper-slide {
            height: 100%;
        }

        .swiper-slide-prev {
            .item {
                img {
                    transform: translate(-100%, -50%);
                    left: 100%;
                    opacity: .5;
                }


            }
        }

        .swiper-slide-next {
            .item {
                img {
                    transform: translate(0%, -50%);
                    left: 0;
                    opacity: .5;
                }

            }
        }

        &.hover-next .swiper-slide-next .item img {
            left: -8%;
            opacity: .8;
        }

        &.hover-prev .swiper-slide-prev .item img {
            left: 108%;
            opacity: .8;
        }

        .swiper-slide-active .item .info {
            opacity: 1;
        }

        .item {
            margin: auto;
            height: 100%;
            width: 100%;
            position: relative;

            img {
                display: block;
                left: 50%;
                top: 50%;
                position: absolute;
                transform: translate(-50%, -50%);
                transition: all .3s ease;
                max-width: 70rem;
                max-height: 40rem;
                opacity: 1;
                width: auto;
                height: auto;
                // left: 0;
                // top: 0;
            }


            .info {
                font-size: var(--small-size);
                // color: white;
                padding-top: .5rem;
                position: absolute;
                // top: 100%;
                opacity: 0;
                transition: opacity .3s .2s;

                span {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
            }


        }

        .swiper-pagination {
            position: absolute;
            bottom: 8rem;
            left: 50%;
            width: auto;
            transform: translate(-50%, 0);
            z-index: 999;
            mix-blend-mode: difference;
        }

        .swiper-pagination-bullet {
            background: #fff;
            height: 1rem;
            width: 1rem;
            margin: 0 .5rem !important;
            opacity: .45;

            &.swiper-pagination-bullet-active {
                opacity: .9;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .slideshow-block {
             .swiper-container {
                height: 100rem;
             }
             .swiper-pagination {
                display: none;
             }
             .item img {
                max-width: 70rem;
                max-height: 80rem;
             }

             .item .info {
                padding-top: 1rem;
                font-size: var(--tiny-size);
                line-height: 1.2;
             }
        }
    }

</style>
